import React from 'react'
import { Checkbox, type CheckboxProps } from '@mui/material'
import type { TableToggleRowsSelectedProps } from 'react-table'

interface Props extends TableToggleRowsSelectedProps, Omit<CheckboxProps, 'onChange' | 'role'> {}

export const IndeterminateCheckbox = React.forwardRef<HTMLButtonElement, Props>(
    ({ indeterminate, ...rest }: Props, ref: any) => {
        const defaultRef = React.useRef()
        const resolvedRef = ref || defaultRef

        React.useEffect(() => {
            resolvedRef.current.indeterminate = indeterminate
        }, [resolvedRef, indeterminate])

        return <Checkbox indeterminate={indeterminate} ref={resolvedRef} {...rest} />
    },
)
